import classNames from "classnames";
import type { ComponentPropsWithoutRef, ReactNode } from "react";
import styles from "./Button.module.css";

type Args = {
  variant: "primary" | "secondary" | "cookie" | "error";
  children: ReactNode;
  className?: string;
} & ComponentPropsWithoutRef<"button">;

export const Button = ({ variant, children, className, ...props }: Args) => {
  return (
    <button
      {...props}
      className={classNames(styles.button, styles[variant], className)}
    >
      {children}
    </button>
  );
};
